module.exports = __webpack_public_path__ + "img/logo.aa2da40f.png";